import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  type PagePaginationRequestDto,
  PagePaginationResponseDtoSchema,
  responseContract,
} from '../../lib';
import { OrganizationDtoSchema } from '../contracts';

const GetOrganizationsResponseDtoSchema = PagePaginationResponseDtoSchema(
  OrganizationDtoSchema
);

export type GetOrganizationsRequestDto = PagePaginationRequestDto<
  {},
  'createdAt'
>;
export type GetOrganizationsResponseDto = z.infer<
  typeof GetOrganizationsResponseDtoSchema
>;

export const getOrganizations = (
  params: GetOrganizationsRequestDto,
  config?: AxiosRequestConfig<GetOrganizationsRequestDto>
) => {
  return api
    .get('/organizations', { params, ...config })
    .then(responseContract(GetOrganizationsResponseDtoSchema));
};
